export enum ContactType {
  account = 'account',
  job = 'job',
}
